export default "__VITE_ASSET__DsnX8BmW__"